// extracted by mini-css-extract-plugin
export default {"cls1":"YP17acrpgNaYj_2l49hX","cls2":"CBgjlavJsi1b8CecZCTQ YP17acrpgNaYj_2l49hX"};